import {FileSearch02Icon, FileX02Icon} from '@/components/ui/icon/Icon'
import {useTranslation} from '@/translations/i18n'
import {useMedicalReportTextAreaStore} from '../../stores/medicalReportTextAreaStore'
import {useMedicalPreviousReportContext} from '../../hooks/useMedicalPreviousReportContext'
import {StyledSplitViewButton} from './style'

export const MedicalReportSplitViewButton = ({currentField}: {currentField: string}) => {
    const {t} = useTranslation()
    const {isSplitView, openSplitView, disableSplit} = useMedicalReportTextAreaStore()
    const {previousReport} = useMedicalPreviousReportContext()

    return previousReport ? (
        <StyledSplitViewButton
            type="button"
            variant="ghost"
            size="sm"
            $isActive={isSplitView}
            onClick={isSplitView ? disableSplit : () => openSplitView(currentField)}
        >
            {isSplitView ? (
                <>
                    <FileX02Icon />
                    {t('medical_records:hide_previous_report')}
                </>
            ) : (
                <>
                    <FileSearch02Icon />
                    {t('medical_records:show_previous_report')}
                </>
            )}
        </StyledSplitViewButton>
    ) : null
}
